import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { SETTINGS_BRIDGE_PORTLET_LOADERS } from '../settings-bridge-portlet-registry';
import { IframeIntegrationBridgeService, SettingsBridgeContent } from '@app/services/iframe-integration-bridge.service';

@Component({
  standalone: true,
  selector: 'ti-settings-bridge-portlet-host',
  imports: [CommonModule],
  template: `
    <div class="settings-bridge-portlet-host-inner">
      <ng-container #outlet></ng-container>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        overflow: hidden;
      }
      .settings-bridge-portlet-host-inner {
        height: 100%;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: var(--scrollbar-background);
      }
    `,
  ],
})
export class SettingsBridgePortletHostComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) componentId!: string;

  @ViewChild('outlet', { read: ViewContainerRef }) outlet!: ViewContainerRef;

  private readonly iframeIntegrationBridgeService = inject(IframeIntegrationBridgeService);

  private createdComponentRef: ComponentRef<unknown> | null = null;

  ngAfterViewInit(): void {
    void this.loadComponent();
  }

  ngOnDestroy(): void {
    if (this.createdComponentRef?.instance) {
      this.iframeIntegrationBridgeService.unregisterBridgeContent(this.componentId);
    }
    this.createdComponentRef = null;
  }

  private async loadComponent(): Promise<void> {
    if (!this.outlet) {
      return;
    }
    const loader = SETTINGS_BRIDGE_PORTLET_LOADERS[this.componentId];
    if (!loader) {
      return;
    }
    const ComponentType = await loader();
    this.outlet.clear();
    this.createdComponentRef = this.outlet.createComponent(ComponentType);

    const instance = this.createdComponentRef.instance as SettingsBridgeContent;
    if (instance && typeof instance === 'object') {
      instance.componentId = this.componentId;
      this.iframeIntegrationBridgeService.registerBridgeContent(this.componentId, instance);
    }
  }
}
